/**
 * Support API (guests)
 * ────────────────────
 * A BARE axios instance — deliberately NOT the shared src/api/axios.js, whose
 * interceptor attaches the logged-in user's Bearer token. Anonymous guests have
 * no user token; instead they pass their scoped guest token explicitly.
 *
 * Endpoints (backend: routes/support_routes):
 *   POST  /support/start                       → { token, guestId, conversationId, messages }
 *   GET   /support/:conversationId/messages    (Bearer guestToken)
 *   POST  /support/:conversationId/messages    (Bearer guestToken)  ← REST fallback
 */

import axios from 'axios';

// Mirror the resolution used elsewhere in the app, with the same hosted
// fallback. Use CRA-style env (process.env.REACT_APP_*) so the build doesn't
// choke on import.meta in a CRA toolchain. The Vite var is read defensively too.
const viteApiUrl =
  typeof import.meta !== 'undefined' && import.meta.env
    ? import.meta.env.VITE_API_URL
    : undefined;

const API_BASE =
  process.env.REACT_APP_API_URL ||
  viteApiUrl ||
  'https://giggs-backend-ff5df60a245f.herokuapp.com/';

const client = axios.create({ baseURL: API_BASE });

export const supportApi = {
  // Public: open (or resume) a guest support thread.
  start: ({ name, email, message }) =>
    client.post('/support/start', { name, email, message }),

  // Guest token: load the full thread (used on resume / reconnect).
  getMessages: (conversationId, token) =>
    client.get(`/support/${conversationId}/messages`, {
      headers: { Authorization: `Bearer ${token}` },
    }),

  // Guest token: REST fallback for sending when the socket is down.
  sendMessage: (conversationId, token, { content, clientMessageId }) =>
    client.post(
      `/support/${conversationId}/messages`,
      { content, clientMessageId },
      { headers: { Authorization: `Bearer ${token}` } }
    ),
};

export default supportApi;
